import { useEffect, useState } from "react";

const InfoGlyph = () => (
  <svg width="43" height="43" viewBox="0 0 43 43" aria-hidden="true">
    <circle cx="21.5" cy="21.5" r="21.5" fill="#000" />
    <path d="M14.3 32.3l.5-2.4h5.4l2.2-10.4h-4.8l.5-2.4h7.7l-2.7 12.8h5.4l-.5 2.4H14.3z" fill="#fff" />
    <circle cx="24.7" cy="11.3" r="2.1" fill="#fff" />
  </svg>
);

const CloseGlyph = () => (
  <svg width="43" height="43" viewBox="0 0 43 43" aria-hidden="true">
    <circle cx="21.5" cy="21.5" r="21.5" fill="#000" />
    <path d="M16 16l11 11M27 16L16 27" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" />
  </svg>
);

const ShareGlyph = () => (
  <svg width="43" height="43" viewBox="0 0 43 43" fill="none" aria-hidden="true">
    <circle cx="21.5" cy="21.5" r="21.5" fill="#000" />
    <g stroke="#fff" strokeWidth="1.23" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="26.2" cy="14.1" r="3.1" />
      <circle cx="13.9" cy="21.3" r="3.1" />
      <circle cx="26.2" cy="28.5" r="3.1" />
      <path d="M16.5 22.8l7.1 4.1M23.6 15.6l-7.1 4.1" />
    </g>
  </svg>
);

export const SideIcons = ({ infoOpen, onInfo }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) return undefined;
    const t = setTimeout(() => setCopied(false), 2200);
    return () => clearTimeout(t);
  }, [copied]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
    } catch (e) {
      const ta = document.createElement("textarea");
      ta.value = window.location.href;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setCopied(true);
  };

  return (
    <>
      <button type="button" className={`jt-icon jt-icon--info ${infoOpen ? "is-raised" : ""}`} onClick={onInfo} aria-label={infoOpen ? "Close info" : "About this work"} data-testid="info-icon-button">
        {infoOpen ? <CloseGlyph /> : <InfoGlyph />}
      </button>
      <button type="button" className={`jt-icon jt-icon--share ${infoOpen ? "is-raised" : ""}`} onClick={copy} aria-label="Copy link" data-testid="share-copy-link-button">
        <ShareGlyph />
      </button>
      {copied && (
        <div className="jt-copied-wrap" data-testid="copy-confirmation">
          <div className="jt-copied">URL copied to Clipboard!</div>
        </div>
      )}
    </>
  );
};
